import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// styles
import styles from './PdpSharedIconBubbles.scss';

import FacebookIcon from 'dibs-icons/exports/Facebook';

// helpers
import classnames from 'classnames';
import { trackFacebookClick } from '../tracking/iconBubblesTracking';
import { facebookShare } from '../../components/social/socialActions';

function onClick({ item }) {
    trackFacebookClick(item.title);
    facebookShare({ newBrowserWindow: true });
}

const className = classnames(styles.bubble, styles.facebook);
function PdpSharedIconBubbleFacebookComponent(props) {
    return (
        <div
            className={className}
            onClick={() => onClick(props)}
            data-tn="pdp-shared-icon-facebook"
        >
            <FacebookIcon className={styles.icon} />
        </div>
    );
}

PdpSharedIconBubbleFacebookComponent.propTypes = {
    item: PropTypes.object.isRequired,
};

export const PdpSharedIconBubbleFacebook = createFragmentContainer(
    PdpSharedIconBubbleFacebookComponent,
    {
        item: graphql`
            fragment PdpSharedIconBubbleFacebook_item on Item {
                title
            }
        `,
    }
);
